module.exports = __webpack_public_path__ + "img/trousers.bf5388fc.png";